$border-color: #cdcdcd;
$background-color-trumpf: #005074;
$background-color-mytrumpf: #bbd03a;

@mixin font-lvl1 {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 18px;
    color: $color-black;
    text-decoration: none;
    position: relative;

    @media only screen and (min-width: $desktop-s-navigation-100) {
        font-size: 20px;
    }
}

@mixin font-lvl2 {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 18px;
    color: $color-black;
    text-decoration: none;
    position: relative;
}

@mixin font-lvl3 {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 18px;
    color: $color-black;
    text-decoration: none;
    position: relative;
}

.ux-iws-nav {
    width: 100%;
    height: 100px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid $border-color;

    @media only screen and (min-width: $desktop-s-navigation-100) {
        align-items: flex-end;
        position: relative;
    }
}

.ux-iws-nav__lvl1 {
    width: 100%;
    left: 0;
    top: -9999vh;
    margin: 0;
    padding: 15px 30px;
    background: $color-white;
    position: absolute;

    @media only screen and (min-width: $desktop-s-navigation-100) {
        margin-bottom: 16px;
        padding: 0;
        left: auto;
        top: auto;
        width: auto;
        display: flex;
        position: relative;
    }

    .ux-iws-nav__lvl1-item {
        padding: 12px 0;
        list-style: none;
        cursor: pointer;

        &:last-of-type {
            margin-bottom: 0;
        }

        > a {
            @include font-lvl1();
        }
    }

    .ux-iws-nav--not-active {
        display: none;
    }

    @media only screen and (min-width: $desktop-s-navigation-100) {
        .ux-iws-nav__lvl1-item {
            margin: 0 15px;
            padding: 0;
            position: relative;
        }

        .ux-iws-nav__lvl1-item:first-of-type {
            margin-left: 0;
        }

        .ux-iws-nav__lvl1-item:last-of-type {
            margin-right: 0;
        }

        ux-icon[name="arrow-right"],
        ux-icon[name="chevron-right"] {
            display: none;
        }

        .ux-iws-nav--not-active {
            display: block;
        }
    }

    @media only screen and (min-width: $desktop-l) {
        .ux-iws-nav__lvl1-item {
            margin: 0 30px;
        }
    }

    .ux-iws-nav__lvl1-item--has-children {
        > a {
            pointer-events: none;
        }
    }

    .ux-iws-nav--active {
        .ux-iws-nav__lvl2 {
            display: block;

            /* stylelint-disable max-nesting-depth, selector-max-compound-selectors */
            @media only screen and (min-width: $desktop-s-navigation-100) {
                visibility: visible;
            }

            /* stylelint-enable max-nesting-depth, selector-max-compound-selectors */
        }
    }

    .ux-iws-nav__lvl1-item::after {
        content: "";
        left: 0;
        height: 0;
        width: 100%;
        bottom: -16px;
        position: absolute;

        .ux-iws-header--trumpf & {
            background-color: $background-color-trumpf;
        }

        .ux-iws-header--mytrumpf & {
            background-color: $background-color-mytrumpf;
        }
    }

    @media only screen and (min-width: $desktop-s-navigation-100) {
        .ux-iws-nav--active::after {
            transition: height 0.25s ease-in-out;
        }

        .ux-iws-nav--active::after,
        .ux-iws-nav__lvl1-item:hover::after {
            height: 4px;
        }
    }

    &--active {
        top: 100px;

        @media only screen and (min-width: $desktop-s-navigation-100) {
            top: auto;
        }
    }
}

.ux-iws-nav__lvl2 {
    left: 0;
    top: 0;
    width: 100%;
    max-width: 1920px;
    background: $color-white;
    padding: 60px 30px 30px;
    position: absolute;
    display: none;
    cursor: default;

    @media only screen and (min-width: $desktop-s-navigation-100) {
        left: 50%;
        transform: translateX(-50%);
        padding: 30px 0 0;
        top: 100px;
        box-shadow: 0 10px 10px rgba(0, 0, 0, 0.1);
        display: block;
        visibility: hidden;
        position: fixed;
        z-index: 1;
    }

    &::before,
    &::after {
        content: "";
        top: -100px;
        width: 12px;
        height: calc(100% + 100px);
        background: $color-white;
        position: absolute;
    }

    &::before {
        left: -11px;
    }

    &::after {
        right: -11px;
    }

    .ux-iws-nav__lvl2-back {
        @include font(bold);
        left: 30px;
        top: 30px;
        font-size: $size-text-small;
        display: block;
        margin: 0 0 20px;
        text-transform: uppercase;
        position: absolute;
        transition: color 0.2s ease-in-out;
        cursor: pointer;

        &::before {
            content: "← ";
        }

        @media only screen and (min-width: $desktop-s-navigation-100) {
            display: none;
        }

        &:hover {
            color: $color-green;
        }
    }

    .ux-iws-nav__lvl2-item {
        width: 100%;
        padding: 12px 0;
        list-style: none;
        cursor: pointer;

        @media only screen and (min-width: $desktop-s-navigation-100) {
            width: 28%;
            padding-left: 30px;
            position: relative;

            /* stylelint-disable max-nesting-depth, selector-max-compound-selectors */
            &::before {
                content: "";
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                background: linear-gradient(
                    to right,
                    #eff0f4,
                    $color-white 100%
                );
                position: absolute;
                opacity: 0;
                transition: opacity 0.2s ease-in-out;
            }
            /* stylelint-enable max-nesting-depth, selector-max-compound-selectors */
        }

        @media only screen and (min-width: $desktop-l) {
            width: 34%;
        }

        @media only screen and (min-width: $desktop-xl) {
            width: 31%;
        }

        > a {
            @include font-lvl2();
        }

        ux-icon[name="arrow-right"],
        ux-icon[name="chevron-right"] {
            font-size: 15px;
            margin-right: 20px;
        }
    }

    .ux-iws-nav__lvl2-item--overview > a {
        @include font(bold);
        font-size: 16px;

        @media only screen and (min-width: $desktop-s-navigation-100) {
            font-size: 18px;
        }
    }

    .ux-iws-nav__lvl2-item--has-children {
        > a {
            pointer-events: none;
        }
    }

    .ux-iws-nav__lvl2-item:last-of-type {
        margin-bottom: 0;

        @media only screen and (min-width: $desktop-s-navigation-100) {
            margin-bottom: 35px;
        }
    }

    .ux-iws-nav--not-active {
        display: none;

        @media only screen and (min-width: $desktop-s-navigation-100) {
            display: block;
        }
    }

    .ux-iws-nav--active {
        .ux-iws-nav__lvl3-wrapper {
            display: flex;

            /* stylelint-disable max-nesting-depth, selector-max-compound-selectors */
            @media only screen and (min-width: $desktop-s-navigation-100) {
                visibility: visible;
            }
            /* stylelint-enable max-nesting-depth, selector-max-compound-selectors */
        }
    }

    .ux-iws-nav__lvl2-item-toolbox {
        margin: 0 -30px;

        @media (min-width: 1024px) {
            margin: 0;
        }
    }

    @media only screen and (min-width: $desktop-s-navigation-100) {
        .ux-iws-nav__lvl2-item.ux-iws-nav--active > a,
        .ux-iws-nav__lvl2-item:not(.ux-iws-nav--not-active):hover > a {
            @include font(bold);
        }

        .ux-iws-nav__lvl2-item.ux-iws-nav--active::before,
        .ux-iws-nav__lvl2-item:hover::before {
            opacity: 1;
        }
    }

    ux-icon[name="arrow-right"],
    ux-icon[name="chevron-right"] {
        display: block;
    }
}

.ux-iws-nav__lvl2-item {
    @media only screen and (min-width: $desktop-s-navigation-100) {
        .ux-iws-header & {
            padding-left: 30px;
        }
    }

    @media only screen and (min-width: $desktop-l) {
        .ux-iws-header & {
            padding-left: 170px;
        }

        .ux-iws-header--100 & {
            padding-left: 30px;
        }
    }

    @media only screen and (min-width: 1700px) {
        .ux-iws-header--100 & {
            padding-left: 170px;
        }
    }
}

.ux-iws-nav__lvl3-wrapper {
    left: 0;
    top: 0;
    width: 100%;
    background: $color-white;
    position: absolute;
    padding: 60px 30px 30px;
    display: flex;
    flex-direction: column;
    z-index: 11;
    display: none;
    cursor: default;

    @media only screen and (min-width: $tablet) {
        flex-flow: row wrap;
    }

    @media only screen and (min-width: $desktop-s-navigation-100) {
        left: 34%;
        width: 20%;
        padding: 0;
        display: flex;
        visibility: hidden;
        position: fixed;

        // required to support IE11
        @media screen and (-ms-high-contrast: none) {
            top: 100px;
        }
    }

    @media only screen and (min-width: $desktop-xl) {
        left: 31%;
    }

    .ux-iws-nav__lvl3-back {
        @include font(bold);
        left: 30px;
        top: 30px;
        font-size: $size-text-small;
        display: block;
        margin: 0 0 20px;
        text-transform: uppercase;
        position: absolute;
        transition: color 0.2s ease-in-out;
        cursor: pointer;

        &::before {
            content: "← ";
        }

        @media only screen and (min-width: $desktop-s-navigation-100) {
            display: none;
        }

        &:hover {
            color: $color-green;
        }
    }
}

.ux-iws-nav__lvl3-wrapper--has-overview-links {
    .ux-iws-nav__lvl3 {
        @media only screen and (min-width: $tablet) {
            padding-top: 52px;

            /* stylelint-disable max-nesting-depth, selector-max-compound-selectors */
            &:nth-of-type(3) {
                padding-top: 0;
            }

            /* stylelint-enable max-nesting-depth, selector-max-compound-selectors */
        }

        @media only screen and (min-width: $desktop-s-navigation-100) {
            padding-top: 83px;

            /* stylelint-disable max-nesting-depth, selector-max-compound-selectors */
            &:nth-of-type(3) {
                padding-top: 83px;
            }

            /* stylelint-enable max-nesting-depth, selector-max-compound-selectors */
        }
    }
}

.ux-iws-nav__lvl3 {
    width: 100%;
    margin: 0;
    padding: 0;
    background: $color-white;
    position: relative;
    cursor: default;

    .ux-iws-nav__lvl3-item:last-of-type {
        margin-bottom: 0;
    }

    @media only screen and (min-width: $tablet) {
        width: 50%;
    }

    @media only screen and (min-width: $desktop-s-navigation-100) {
        position: fixed;
        padding: 30px 0 35px;
        background: transparent;

        &:nth-of-type(1) {
            left: 28%;
            width: 24%;
        }

        &:nth-of-type(1)::before {
            content: "";
            width: 1px;
            height: 100%;
            left: 0;
            top: 0;
            border-right: 1px solid $border-color;
            position: absolute;
            z-index: 1;
        }

        &:nth-of-type(2) {
            left: 52%;
            width: 24%;
        }

        &:nth-of-type(3) {
            left: 76%;
            width: 24%;
        }
    }

    @media only screen and (min-width: $desktop-l) {
        &:nth-of-type(1) {
            left: 34%;
            width: 22%;
        }

        &:nth-of-type(2) {
            left: 56%;
            width: 22%;
        }

        &:nth-of-type(3) {
            left: 78%;
            width: 22%;
        }
    }

    @media only screen and (min-width: $desktop-xl) {
        &:nth-of-type(1) {
            left: 31%;
            width: 23%;
        }

        &:nth-of-type(2) {
            left: 54%;
            width: 23%;
        }

        &:nth-of-type(3) {
            left: 77%;
            width: 23%;
        }
    }

    .ux-iws-nav__lvl3-item {
        list-style: none;
        padding: 12px 20px 12px 0;
        position: relative;
        cursor: pointer;

        > a {
            @include font-lvl3();
        }

        &::before {
            content: "";
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background: linear-gradient(to right, #eff0f4, $color-white 100%);
            position: absolute;
            opacity: 0;
            transition: opacity 0.2s ease-in-out;
        }
    }

    .ux-iws-nav__lvl3-item--overview {
        @media only screen and (min-width: $tablet) {
            top: 0;
            position: absolute;
        }

        @media only screen and (min-width: $desktop-s-navigation-100) {
            top: 31px;
        }
    }

    .ux-iws-nav__lvl3-item--overview > a {
        @include font(bold);
        font-size: 16px;
        white-space: nowrap;

        @media only screen and (min-width: $desktop-s-navigation-100) {
            font-size: 18px;
        }
    }

    .ux-iws-nav__lvl3-item--subheadline {
        @include font(bold);
        font-size: 13px;
        text-transform: uppercase;
        text-decoration: none;
        cursor: default;
        margin-bottom: -10px;
    }

    @media only screen and (min-width: $desktop-s-navigation-100) {
        .ux-iws-nav__lvl3-item {
            padding: 12px 20px 12px 30px;
        }

        .ux-iws-nav__lvl3-item:hover > a {
            @include font(bold);
        }

        .ux-iws-nav__lvl3-item:hover::before {
            opacity: 1;
        }

        .ux-iws-nav__lvl3-item--subheadline:hover::before {
            opacity: 0;
        }
    }

    @media only screen and (min-width: $desktop-l) {
        .ux-iws-nav__lvl3-item {
            padding: 12px 30px 12px 50px;
        }
    }

    .ux-iws-nav__lvl3-item:last-of-type {
        margin-bottom: 0;
    }
}

.ux-iws-nav__meta {
    display: flex;
    align-items: center;

    .ux-iws-nav__meta-container-header {
        margin-right: 10px;

        @media only screen and (min-width: $desktop-s-navigation-100) {
            right: -20px;
            top: 0;
            margin: 0;
            position: absolute;
            max-width: calc(100% + 40px);
            overflow-x: scroll;
            padding: 0 20px 15px;
            //hide horizontal scrollbar
            -ms-overflow-style: none;
            scrollbar-width: none;
        }
    }

    .ux-iws-nav__meta-container-header::-webkit-scrollbar {
        @media only screen and (min-width: $desktop-s-navigation-100) {
            display: none;
        }
    }
}

.ux-iws-nav__eyecatcher {
    left: 130px;
    bottom: 0;
    padding: 3px 15px 4px;
    background: $color-green;
    position: absolute;
    cursor: default;

    @media only screen and (min-width: $tablet) {
        left: 150px;
    }

    @media only screen and (min-width: $desktop-s-navigation-100) {
        left: auto;
        right: 0;
    }

    span {
        color: $color-white;
    }

    .ux-iws-header--active & {
        display: none;
    }

    .ux-iws-header--100 & {
        background: $color-blue-highlight-1;
        left: 200px;
        white-space: nowrap;

        @media only screen and (max-width: 374px) {
            display: none;
        }

        @media only screen and (min-width: $tablet) {
            left: 280px;
        }

        @media only screen and (min-width: $desktop-s-navigation-100) {
            left: auto;
            right: 0;
        }
    }
}
